import React, { useRef } from 'react'
import MainNavigation from './MainNavigation'
import { NavContextProvider } from './useNavContext'
import { getMainNavigationMenu } from './getMainNavigationMenu'
import { prependHostName } from '@toasttab/shared/src/utils/siteUtils'
import { NavControllerProps, SiteRegionTypes } from './ContentfulNavigation.d'

const NavController = ({
  headerContent,
  localizedEntries,
  packageName,
  siteId,
  siteMetadata
}: NavControllerProps) => {
  const siteRegion = headerContent.country.toLowerCase() as SiteRegionTypes
  const headerRef = useRef(null)

  const menus = headerContent?.navMenuItems
    ? [...headerContent.navMenuItems]
    : []

  //Prepend https://pos.toasttab.com for support.toasttab.com
  const navigationData =
    packageName === 'support'
      ? prependHostName(
          JSON.stringify(getMainNavigationMenu(menus, siteRegion)),
          siteMetadata.hostName
        )
      : getMainNavigationMenu(menus, siteRegion)

  const heapClasses = {
    login: `${siteRegion}_topnav_login`,
    mainNav:
      siteRegion === 'us' ? `topnav_entire_v` : `${siteRegion}_topnav_entire`,
    regionSwitcher: `${siteRegion}_topnav_region`,
    requestDemo: `${siteRegion}_topnav_demo`,
    restaurantSearch: `${siteRegion}_topnav_restaurants`
  }
  const navContext = {
    heapClasses,
    headerRef,
    localizedEntries,
    mobileShowcase: headerContent.mobileShowcase,
    navigationData:
      typeof navigationData === 'string'
        ? JSON.parse(navigationData)
        : navigationData,
    salesPhoneNumber: headerContent.salesPhoneNumber,
    showLogin: headerContent.showLogin,
    showRegionSelector: headerContent.showRegionSelector,
    showRequestDemo: headerContent.showRequestDemo,
    showRestaurantSearch: headerContent.showRestaurantSearch,
    showSalesInDesktopNav: headerContent.showSalesInDesktopNav,
    showSalesInMobileMenu: headerContent.showSalesInMobileMenu,
    showSalesInMobileNav: headerContent.showSalesInMobileNav,
    siteId,
    siteRegion
  }

  return (
    <NavContextProvider value={navContext}>
      <div ref={headerRef}>
        <MainNavigation />
      </div>
    </NavContextProvider>
  )
}

export default NavController
